module.exports = __webpack_public_path__ + "img/1502280936.a79a8434.jpg";